module.exports = __webpack_public_path__ + "img/ct-point-of-connection-uk.9b7c2082.png";